var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mapComponent)?_c('map-modal',{attrs:{"title":_vm.mapComponent.popupTitle},on:{"close":_vm.onClose}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.mapComponent.popupContent)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }